<template>
  <div class="ma-2 overflow-hidden">
    <v-flex>
      <span class="body-2">{{$t(label)}}</span>
    </v-flex>
    <v-flex :class="{scrollable: scroll}">
      <div class="prevent-overflow" v-if="text || number">{{$t(text)}}{{number}}</div>
      <div class="prevent-overflow" v-if="date">{{date | date}}</div>
      <a target="_blank" class="prevent-overflow" v-if="link" :href="link.url">{{$t(link.urlKey)}}</a>
      <a target="_blank" class="prevent-overflow link-break" v-bind:key="link.url" v-if="links" v-for="link in links" :href="transformUrl(link.url)">{{link.label}}</a>
    </v-flex>
  </div>
</template>

<script>
  import DateFormat from '../../../mixins/DateFormat'

  export default {
    name: 's-textbox',
    props: ['label', 'text', 'number', 'scroll', 'date', 'link', 'links'],
    mixins: [DateFormat],
    data () {
      return {}
    },
    methods: {
      transformUrl (url) {
        let regex = '^https?://'
        if (!url.startsWith(regex)) {
          url = 'http://' + url
        }
        return url
      }
    }
  }
</script>

<style scoped>
.link-break {
  display: block;
}

  @media (min-width: 600px) {
    .scrollable {
      max-height: 200px;
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/intervention/studentProfileIntervention/STextbox.vue